import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import dayjs from "dayjs";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { useBookingByIdWithMetaQueryObserver } from "../../../../api/services";
import DialogCloseButton from "../../../../components/DialogCloseButton";
import useDialog from "../../../../hooks/useDialog";
import { BookingAction, RouteParams } from "../../../../types";
import { InsertBookingStateAction } from "../../../insert/types";

const DraftEditAction = () => {

    const { t } = useTranslation('booking');

    const { dispatchGlobalData } = useContext(GlobalContext);

    const { id } = useParams<RouteParams>();

    const navigate = useNavigate();

    const dialog = useDialog();

    const bookingQuery = useBookingByIdWithMetaQueryObserver(id);

    const insertPath = '/booking/insert';
    const insertRecoveryPath = '/recovery/insert-booking';

    const onClickConfirm = useCallback(() => {
        const currentTimestamp = dayjs();
        const expirationDateTime = dayjs(bookingQuery.data?.booking.expirationDateTime);
        if (!expirationDateTime.isValid() || currentTimestamp.isAfter(expirationDateTime)) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t('message.error.default'),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            return;
        }
        let pathToNavigate = bookingQuery.data?.booking.recovery ? insertRecoveryPath : insertPath;
        navigate(pathToNavigate, {
            state: {
                booking: bookingQuery.data?.booking,
                action: InsertBookingStateAction.DraftEdit
            }
        });
    }, [bookingQuery.data]);

    return (
        <>
            {bookingQuery.data?.permissions.actions[BookingAction.Edit] &&
                <>
                    <Button onClick={dialog.handleShow}>
                        {t("label.retrieveBooking")}
                    </Button>
                    <Dialog
                        open={dialog.open}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogCloseButton onClick={dialog.handleClose}/>
                        <DialogTitle>
                            {t('label.bookingEditing')}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {t("message.info.retrieve_booking_action")}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="outlined"
                                onClick={dialog.handleClose}
                            >
                                {t("label.cancel")}
                            </Button>
                            <Button onClick={onClickConfirm}>
                                {t("label.confirm")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }
        </>
    )
};

export default DraftEditAction;
